import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useActions } from 'hooks/useActions';
import * as actions from './actions';
import {
  OuterContainer,
  ContainerHeading,
  IntegrationContainer,
  PrivacyPreviewHeading,
  IntegrationFieldLabel,
  TextInput,
  FlexContainer,
} from './styles';
import { Button } from 'components/Button/RoundButton';
import YesNoModal from 'components/Modals/yesNoModal';
import Dropdown from 'components/CustomizableDropdown/CustomizableDropdown';
import { userRoles } from 'constants/users';

export default React.memo(() => {
  const navigate = useNavigate();

  const {
    settings: { ttUserToken, lever },
  } = useSelector((state) => state.SettingsPageReducer);
  let { userRole, company, department } = useSelector((state) => state.auth);

  const { updateLeverIntegrationUser, createTeamTailorIntegrationUser } = useActions(actions);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({});
  const [integrationToken, setIntegrationToken] = useState(lever.integrationToken);
  const [signatureToken, setSignatureToken] = useState(lever.signatureToken);
  const [webhookUrl, setWebhookUrl] = useState(lever.webhookUrl);
  const [stages, setStages] = useState(lever.stages);
  const [triggerStage, setTriggerStage] = useState(lever.triggerStage);

  if (userRole) {
    if (![userRoles.COMPANY_ADMIN, userRoles.SUPER_ADMIN].includes(userRole)) navigate('/tests');
  }

  useEffect(() => {
    if (!integrationToken && lever.integrationToken) setIntegrationToken(lever.integrationToken);
    if (!signatureToken && lever.signatureToken) setSignatureToken(lever.signatureToken);
    if (!triggerStage && lever.triggerStage) setTriggerStage(lever.triggerStage);
    if (!webhookUrl && lever.webhookUrl) setWebhookUrl(lever.webhookUrl);
    if (!stages?.length && lever.stages) setStages(lever.stages);
  }, [lever, integrationToken, signatureToken, triggerStage, webhookUrl, stages]);

  const copyToken = async (id) => {
    let copyText = document.getElementById(id);
    await navigator.clipboard.writeText(copyText.value);
    toast.success('Copied');
  };

  const confirmModal = (isConfirmed) => {
    setShowConfirmationModal(false);
    if (isConfirmed)
      createTeamTailorIntegrationUser({
        companyId: company?._id,
        departmentId: department?._id,
      });
  };

  return (
    <OuterContainer>
      {showConfirmationModal && (
        <YesNoModal modalInfo={modalInfo} confirm={(isConfirmed) => confirmModal(isConfirmed)} />
      )}
      <ContainerHeading>Integrations</ContainerHeading>
      <IntegrationContainer>
        <PrivacyPreviewHeading>Lever</PrivacyPreviewHeading>
        <IntegrationFieldLabel>Integration Token</IntegrationFieldLabel>
        <TextInput
          isEditing={true}
          height="30px"
          margin="0 0 15px 0"
          onChange={(e) => setIntegrationToken(e.target.value)}
          value={integrationToken}
        />
        {lever.integrationToken && (
          <>
            <IntegrationFieldLabel>Signature Token</IntegrationFieldLabel>
            <TextInput
              isEditing={true}
              height="30px"
              margin="0 0 15px 0"
              onChange={(e) => setSignatureToken(e.target.value)}
              value={signatureToken}
            />

            <IntegrationFieldLabel>Trigger Stage</IntegrationFieldLabel>
            <Dropdown
              options={stages}
              value={triggerStage}
              width="100%"
              onChange={(returnedValue) => setTriggerStage(returnedValue.value)}
            />
            <IntegrationFieldLabel margin="15px 0 0 0">Webhook URL</IntegrationFieldLabel>
            <FlexContainer>
              <TextInput isEditing={true} disabled={true} height="33px" margin="0" id="webhookUrl" value={webhookUrl} />
              <Button small primaryBlue primaryGreenBorder removeMargin onClick={() => copyToken('webhookUrl')}>
                <i className="fa fa-copy"></i>
              </Button>
            </FlexContainer>
          </>
        )}
        <Button
          small
          primaryBlue
          primaryGreenBorder
          removeMargin
          margin="15px 0 0 0px"
          onClick={() =>
            updateLeverIntegrationUser({
              integrationToken,
              signatureToken,
              triggerStage,
              companyId: company?._id,
              departmentId: department?._id,
            })
          }
        >
          {lever.integrationToken ? 'Save' : 'Add Integration'}
        </Button>
      </IntegrationContainer>
      <IntegrationContainer>
        <PrivacyPreviewHeading>TeamTailor</PrivacyPreviewHeading>
        {ttUserToken && (
          <>
            <IntegrationFieldLabel>Integration Token</IntegrationFieldLabel>
            <FlexContainer>
              <TextInput
                isEditing={true}
                height="33px"
                margin="0"
                disabled={true}
                id="ttUserToken"
                value={ttUserToken}
              />
              <Button small primaryBlue primaryGreenBorder removeMargin onClick={() => copyToken('ttUserToken')}>
                <i className="fa fa-copy"></i>
              </Button>
            </FlexContainer>
          </>
        )}
        {!ttUserToken && (
          <Button
            small
            primaryBlue
            primaryGreenBorder
            removeMargin
            margin="15px 0"
            onClick={() => {
              setShowConfirmationModal(true);
              setModalInfo({
                title: 'Confirmation',
                body: 'Are you sure you want to create the TeamTailor user?',
              });
            }}
          >
            Activate
          </Button>
        )}
      </IntegrationContainer>
    </OuterContainer>
  );
});
